export default function DateIcon({ width = 14, height = 15 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.8125 5.1875H13.1875M10.375 0.6875V2.9375M3.625 0.6875V2.9375M1.375 1.8125H12.625C12.9357 1.8125 13.1875 2.06434 13.1875 2.375V13.625C13.1875 13.9357 12.9357 14.1875 12.625 14.1875H1.375C1.06434 14.1875 0.8125 13.9357 0.8125 13.625V2.375C0.8125 2.06434 1.06434 1.8125 1.375 1.8125Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
